import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const sidebarSelectedMenuItemState = atom({
  key: 'SidebarSelectedMenuItemState',
  default: null,
  effects: []
});
